import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Mousetrap from 'mousetrap';
import cogoToast from 'cogo-toast';
import logo from '../static/logo/logo_and_icon.png';
import panelLeft from '../static/home/panelLeftWallpaper-1.png';

import { requestNewPassword, resetPassword } from '../api/users';
import { loginUser, registerUser } from '../actions/UserActions';

import './Auth.scss';

class Auth extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    loginUser: PropTypes.func.isRequired,
    registerUser: PropTypes.func.isRequired,
  };

  state = {
    email: '',
    password: '',
    inForgotPasswordMode: false,

    mode: window.location.href.includes('signup') ? 'signup' : 'login', // signup, loging, request-token, reset-password

    isAuthenticating: false,
    isRequestingResetToken: false,
    isResettingPassword: true,

    inAdminMode: false,
  };

  componentDidMount() {
    /* Password confirmation returns a token. */
    this.getResetToken() && this.setMode('reset-password');

    Mousetrap.bind('ctrl+c+b', () => this.setState({ inAdminMode: !this.state.inAdminMode }));
    window.__ADD_EVENT__('Login - Page View');
  }

  componentWillUnmount() {
    Mousetrap.unbind('CTRL+C+B');
  }

  getResetToken = () => this.props.match?.params?.token;
  getResetUid = () => this.props.match?.params?.uid;

  login = async (e) => {
    const { email, password } = this.state;
    e.preventDefault();
    this.setState({ isPerformingAction: true });

    const token = this.getResetToken();
    const uid = this.getResetUid();

    if (token) {
      try {
        const resetResp = await resetPassword({ uid, token, new_password1: password, new_password2: password });
        cogoToast.success(_.first(_.values(resetResp)) || 'Reset was successful - Logging In!');
      } catch (error) {
        cogoToast.error(_.first(_.values(error)) || 'There was an error.');
        this.setState({ isPerformingAction: false });
        return;
      }
    }

    const userResp = await this.props.loginUser({ email, password });
    userResp.user && this.props.history.push('/');
    this.setState({ isPerformingAction: false });
  };

  register = async (e) => {
    const { email, password } = this.state;
    e.preventDefault();
    this.setState({ isPerformingAction: true });
    const userResp = await this.props.registerUser({ email, password });
    userResp.user && this.props.history.push('/');
    this.setState({ isPerformingAction: false });
  };

  requestNewPassword = async (e) => {
    const { email } = this.state;
    e.preventDefault();
    this.setState({ isPerformingAction: true });

    try {
      await requestNewPassword({ email });
      cogoToast.success(`Sent reset link to ${email}!`);
    } catch (error) {
      cogoToast.error(_.first(_.values(error)) || 'There was an error.');
    }
    this.setState({ isPerformingAction: false });
  };

  toggleForgotPassword = () => {
    this.setState({ inForgotPasswordMode: !this.state.inForgotPasswordMode, isResettingPassword: false });
  };

  toggleResettingPassword = () => {
    window.history.pushState(null, '', '/');
    this.setState({ isResettingPassword: !this.state.isResettingPassword, inForgotPasswordMode: true });
  };

  setMode = (newMode) =>
    ['signup', 'login', 'request-token', 'reset-password'].includes(newMode)
      ? this.setState({ mode: newMode })
      : console.error(`${newMode} is not a valid mode.`);

  render() {
    const { email, mode, password, isPerformingAction, inAdminMode } = this.state;
    return (
      <div className='auth-outer-container'>
        <div className='left-panel'>
          <img src={panelLeft} className='panel-wallpaper' alt='Flowing Design' />
        </div>
        <div className='right-panel'>
          <form onSubmit={this.login} className='auth-inner-container'>
            <div className='logo'>
              <img src={logo} className='logo' alt='ChipBrain Logo' />
            </div>
            <div className='welcome-header-container'>
              <div className='welcome-header'>Welcome Back</div>
              {inAdminMode && (
                <>
                  {mode === 'signup' ? (
                    <div className='welcome-subheader'>
                      Have an account?{' '}
                      <span onClick={() => this.setState({ mode: 'login' })} to='login'>
                        Log In
                      </span>
                    </div>
                  ) : (
                    <div className='welcome-subheader'>
                      New to Chipbrain?{' '}
                      <span onClick={() => this.setState({ mode: 'signup' })} to='signup'>
                        Sign Up
                      </span>
                    </div>
                  )}
                </>
              )}
            </div>
            {mode === 'request-token' ? (
              <>
                <input placeholder='Your Email Address' type='email' value={email} onChange={(e) => this.setState({ email: e.target.value })} />
                <button onClick={this.requestNewPassword} className='submit-btn'>
                  {isPerformingAction ? 'Requesting...' : 'Request New Password'}
                </button>
                <div onClick={() => this.setMode('login')} className='forgot-password-btn'>
                  Back to Log In
                </div>
              </>
            ) : (
              <>
                <input placeholder='Your Email Address' type='email' value={email} onChange={(e) => this.setState({ email: e.target.value })} />
                {mode === 'request-token' ? null : (
                  <input
                    placeholder={`${mode === 'reset-password' ? `New` : 'Your'} Password`}
                    type='password'
                    value={password}
                    onChange={(e) => this.setState({ password: e.target.value })}
                  />
                )}
                <button onClick={mode === 'signup' ? this.register : this.login} className='submit-btn'>
                  {isPerformingAction
                    ? mode === 'signup'
                      ? 'Signing Up...'
                      : 'Logging In...'
                    : mode === 'signup'
                    ? 'Sign Up'
                    : `Log In${mode === 'reset-password' ? ' With New Password' : ''}`}
                </button>
                {mode === 'signup' ? null : mode === 'reset-password' ? (
                  <div onClick={this.toggleForgotPassword} className='forgot-password-btn'>
                    Request New Reset Email
                  </div>
                ) : (
                  <div onClick={() => this.setMode('request-token')} className='forgot-password-btn'>
                    Forgot your password?
                  </div>
                )}
              </>
            )}

            <div className='my-10 block text-center px-6'>
              Don't have an account?
              <Link className='text-indigo-500 hover:text-indigo-700 visited:text-indigo-500 ml-2 font-medium' to='/user/invite'>
                Register
              </Link>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  loginUser,
  registerUser,
  requestNewPassword,
})(withRouter(Auth));
